import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="200" height="26" fill="none" viewBox="0 0 200 26" {...props}>
      <g id="dostavka_logo 3" clipPath="url(#clip0_2436_148369)">
        <path
          id="Vector"
          fill="#000"
          d="M106.882 4.339h9.596v-2.48h-9.596zm6.491-2.48v18.332h3.105V1.859zm-5.978 16.248q.309-.58.565-1.582.282-1.029.461-2.638.18-1.635.257-4.062l.257-7.966h-2.925l-.257 7.544q-.102 3.614-.461 5.67-.334 2.058-1.078 3.034zm-1.231 5.908v-3.824h9.082v3.824h2.899v-6.303h-14.88v6.303z"
        ></path>
        <path
          id="Vector_2"
          fill="#000"
          d="M125.136 6.66q-2.514 0-4.105 1.794-1.59 1.767-1.591 5.117 0 2.215.719 3.772.718 1.53 2.001 2.32 1.282.792 2.976.792 2.514 0 4.105-1.767 1.59-1.794 1.591-5.144 0-2.215-.719-3.745t-2.001-2.321q-1.282-.818-2.976-.818m0 11.316q-1.283 0-1.924-1.055-.616-1.055-.616-3.35 0-2.322.616-3.376.641-1.056 1.924-1.055 1.283 0 1.898 1.055.642 1.055.642 3.35 0 2.32-.642 3.376-.615 1.055-1.898 1.055"
        ></path>
        <path
          id="Vector_3"
          fill="#000"
          d="M138.423 20.455q1.051 0 1.821-.211a3.6 3.6 0 0 0 1.335-.607V17.08q-.59.42-1.309.66-.719.236-1.667.237-1.643 0-2.361-1.214t-.718-3.27q0-2.163.795-3.245.82-1.107 2.309-1.107.873 0 1.668.263.82.263 1.283.554V7.293q-.488-.29-1.335-.448-.82-.185-1.949-.185-1.95 0-3.284.897-1.309.87-1.976 2.427-.666 1.556-.667 3.587 0 3.323 1.488 5.117 1.514 1.767 4.567 1.767"
        ></path>
        <path id="Vector_4" fill="#000" d="M152.971 9.403v-2.48h-10.237v2.48h3.592v10.788h3.053V9.403z"></path>
        <path
          id="Vector_5"
          fill="#000"
          d="M160.597 17.024q-.281.422-.821.739-.538.316-1.359.316-.975 0-1.463-.501-.462-.528-.462-1.372 0-1.134.847-1.582.873-.475 2.822-.475h.436zm3.053-5.882q0-2.4-1.206-3.402-1.205-1.03-3.617-1.03-1.513 0-2.694.397-1.154.395-1.847.817v2.612a5 5 0 0 1 1.078-.607 7.7 7.7 0 0 1 1.513-.501 6.4 6.4 0 0 1 1.591-.211q1.103 0 1.616.448t.513 1.504v.738h-.487q-3.49 0-5.131 1.134-1.617 1.134-1.617 3.139t1.078 3.112q1.103 1.082 2.873 1.082 1.36 0 2.027-.37a4.7 4.7 0 0 0 1.129-.87h.128q.026.263.077.554.077.29.154.501h2.976a35 35 0 0 1-.154-3.244z"
        ></path>
        <path
          id="Vector_6"
          fill="#000"
          d="M171.44 20.191q2.257 0 3.54-.976t1.283-2.875q0-1.477-.923-2.242-.924-.79-2.566-.897l.051.238q1.335-.21 2.13-.976.82-.792.821-2.163 0-3.375-4.285-3.376h-4.156v2.32h3.797q1.719 0 1.719 1.53 0 .687-.487 1.082-.462.396-1.335.396h-3.668v2.295h3.822q2.002 0 2.002 1.582 0 .924-.539 1.345-.539.396-1.463.396h-3.822v2.321zm-5.336-13.267V20.19h2.976V6.924z"
        ></path>
        <path
          id="Vector_7"
          fill="#000"
          d="M185.875 20.191h3.464l-4.9-7.042 4.31-6.225h-3.078l-4.311 6.225V6.924h-3.053V20.19h3.053v-6.41z"
        ></path>
        <path
          id="Vector_8"
          fill="#000"
          d="M196.7 17.024q-.282.422-.821.739-.539.316-1.36.316-.975 0-1.463-.501-.461-.528-.462-1.372 0-1.134.848-1.582.872-.475 2.821-.475h.437zm3.052-5.882q0-2.4-1.205-3.402-1.205-1.03-3.618-1.03-1.513 0-2.694.397-1.153.395-1.847.817v2.612q.41-.317 1.079-.607a7.7 7.7 0 0 1 1.513-.501 6.4 6.4 0 0 1 1.59-.211q1.103 0 1.617.448.513.448.513 1.504v.738h-.488q-3.49 0-5.131 1.134-1.616 1.134-1.616 3.139t1.076 3.112q1.104 1.082 2.875 1.082 1.36 0 2.026-.37a4.6 4.6 0 0 0 1.129-.87h.129q.024.263.076.554.079.29.155.501h2.976a35 35 0 0 1-.155-3.244z"
        ></path>
        <path
          id="Vector_9"
          fill="#000"
          d="M21.55 6.924v5.248h-4.078V6.924h-3.053V20.19h3.053v-5.54h4.079v5.54h3.053V6.924zm16.831 10.788h-1.36V6.924H28.12v1.134q0 1.635-.103 3.455a31 31 0 0 1-.385 3.455q-.256 1.635-.795 2.744h-.95v5.512h2.823v-3.033h6.85v3.033h2.822zm-4.413 0h-4.31q.411-1.004.642-2.4.256-1.425.333-2.876.103-1.477.103-2.637v-.396h3.232zm7.26-3.034h8.416v-1.662q0-2.32-.616-3.692-.615-1.399-1.744-2.031t-2.669-.633q-1.846 0-3.078.897-1.206.896-1.822 2.479-.59 1.556-.59 3.56 0 3.457 1.59 5.17 1.591 1.689 4.516 1.689 1.463 0 2.54-.343t1.745-.818v-2.558q-.719.501-1.822.87a6.8 6.8 0 0 1-2.206.37q-1.797 0-2.514-.924-.693-.95-.693-2.875V12.7q0-3.56 2.283-3.56 1.13 0 1.54.87.436.844.436 2.083v.897l1.026-.633h-6.337zm18.037 5.513h3.463l-4.9-7.043 4.31-6.224H59.06l-4.31 6.224V6.924h-3.054V20.19h3.053v-6.41zm9.339.264q1.05 0 1.821-.211a3.6 3.6 0 0 0 1.334-.607v-2.559q-.59.423-1.308.66t-1.668.237q-1.641 0-2.36-1.213t-.719-3.27q0-2.164.796-3.245.82-1.108 2.309-1.108.872 0 1.668.264.82.264 1.282.554V7.293q-.488-.29-1.334-.449-.82-.184-1.95-.184-1.95 0-3.284.897-1.308.87-1.975 2.426t-.667 3.587q0 3.324 1.488 5.117 1.513 1.768 4.567 1.768M8.749 20.19h3.104V1.859H7.338q-3.413 0-5.183 1.662Q.41 5.156.41 7.794q0 2.11.95 3.508.949 1.398 2.694 2.69L0 20.191h3.36l4.516-6.937-1.565-1.082a14 14 0 0 1-1.59-1.266 4.3 4.3 0 0 1-.924-1.398q-.308-.79-.308-1.899 0-1.451.975-2.347 1-.923 2.9-.923h1.385z"
        ></path>
        <g id="Clip path group">
          <mask
            id="mask0_2436_148369"
            width="25"
            height="26"
            x="75"
            y="0"
            maskUnits="userSpaceOnUse"
            style={{maskType: 'luminance'}}
          >
            <g id="clip0_226_1903">
              <path
                id="Vector_10"
                fill="#fff"
                d="M87.753.5C81.04.5 75.6 6.094 75.6 12.994S81.04 25.49 87.753 25.49c6.712 0 12.153-5.594 12.153-12.495S94.465.5 87.753.5"
              ></path>
            </g>
          </mask>
          <g mask="url(#mask0_2436_148369)">
            <g id="Group">
              <path
                id="Vector_11"
                fill="#000"
                d="M87.753.5C81.04.5 75.6 6.094 75.6 12.994S81.04 25.49 87.753 25.49c6.712 0 12.153-5.594 12.153-12.495S94.465.5 87.753.5"
              ></path>
              <g id="Mask group">
                <mask
                  id="mask1_2436_148369"
                  width="32"
                  height="34"
                  x="68"
                  y="-4"
                  maskUnits="userSpaceOnUse"
                  style={{maskType: 'alpha'}}
                >
                  <g id="Group_2">
                    <path
                      id="Vector_12"
                      fill="#C4C4C4"
                      d="m69.442 4.753 13.656-8.259a2.04 2.04 0 0 1 2.121 0l13.656 8.259a2.16 2.16 0 0 1 1.031 1.854v12.778c0 .761-.392 1.467-1.03 1.853l-13.657 8.259a2.04 2.04 0 0 1-2.121 0l-13.656-8.259a2.16 2.16 0 0 1-1.032-1.853V6.607c0-.763.393-1.468 1.032-1.854"
                    ></path>
                  </g>
                </mask>
                <g mask="url(#mask1_2436_148369)">
                  <g id="Group_3">
                    <path
                      id="Vector_13"
                      fill="url(#paint0_linear_2436_148369)"
                      d="M84.158-4.146 68.41 5.377l15.748 9.524 15.748-9.524z"
                    ></path>
                    <path
                      id="Vector_14"
                      fill="url(#paint1_radial_2436_148369)"
                      d="M68.41 20.615V5.377L84.158 14.9v15.238z"
                    ></path>
                    <path
                      id="Vector_15"
                      fill="url(#paint2_radial_2436_148369)"
                      d="M99.906 20.615V5.377L84.158 14.9v15.238z"
                    ></path>
                    <path
                      id="Vector_16"
                      fill="url(#paint3_radial_2436_148369)"
                      fillRule="evenodd"
                      d="M76.08-2.385 93.79 8.443c.346.211.558.594.558 1.008v18.782h-4.632V12.159a1.18 1.18 0 0 0-.558-1.008L73.712 1.708z"
                      clipRule="evenodd"
                    ></path>
                  </g>
                </g>
              </g>
              <path
                id="Vector_17"
                fill="#000"
                fillRule="evenodd"
                d="m80.007 4.79.406-.179 1.627.952.754-.416-1.625-.953.406-.238-2.613-.654zm1.916-1.072.407-.238 1.626.953.813-.358-1.626-1.011.406-.238-2.613-.596zm.058 2.262 3.485-1.964.348.238-3.484 1.964z"
                clipRule="evenodd"
              ></path>
              <path
                id="Vector_18"
                fill="#000"
                fillRule="evenodd"
                d="M86.053 8.594c-.917-.65-.802-1.595.172-2.127.975-.59 2.523-.472 3.383.178.745.531.688 1.418.86 2.718 0 .118-.115.177-.287.177-1.49-.296-3.21-.355-4.128-.946m2.523-.413c.459-.237.459-.71.057-1.005-.401-.295-1.089-.354-1.548-.059-.458.237-.458.71-.057 1.005.401.236 1.09.295 1.548.059"
                clipRule="evenodd"
              ></path>
              <path
                id="Vector_19"
                fill="#000"
                d="m93.416 11.135-1.329.76-.159.551.495-.269-.664 1.942.17-1.41-.477.25.139-.745-1.122.66c.004.168.017.618.036 1.068.06 1.556.95 1.581 1.244 1.546.002.207.074.922-.107 1.332-.18.41-.51.516-.8.724-.156.11-.072.344.243.18.314-.164 1.455-.874 1.832-1.062.193-.096.222-.37-.085-.23-.847.388-.745-.275-.745-.51s-.003-.296 0-.58c1.3-1.748 1.428-3.533 1.33-4.207"
              ></path>
              <path
                id="Vector_20"
                fill="#000"
                fillRule="evenodd"
                d="m90.469 21.965.35-.18v2.036l.703-.42v-2.035l.352-.18-.703-1.856zm1.698-.958.35-.18v2.036l.703-.42v-2.035l.352-.18-.762-1.916zm-1.698 3.473 3.044-1.797v.48l-3.044 1.795z"
                clipRule="evenodd"
              ></path>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <radialGradient
          id="paint1_radial_2436_148369"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(-129.289 48.605 -5.28)scale(17.7195 16.5171)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CA8D32"></stop>
          <stop offset="1" stopColor="#F2C888"></stop>
        </radialGradient>
        <radialGradient
          id="paint2_radial_2436_148369"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(-28.056 87.685 -147.974)scale(20.046 18.4024)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4892F"></stop>
          <stop offset="1" stopColor="#E6BE81"></stop>
        </radialGradient>
        <radialGradient
          id="paint3_radial_2436_148369"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(31.465 33.359 132.314)scale(22.8071 16.9142)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF6E8"></stop>
          <stop offset="0.678" stopColor="#FFF9EF"></stop>
          <stop offset="1" stopColor="#F0DBBC"></stop>
        </radialGradient>
        <linearGradient
          id="paint0_linear_2436_148369"
          x1="83.528"
          x2="84.631"
          y1="-3.118"
          y2="12.044"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE7C2"></stop>
          <stop offset="1" stopColor="#E3B673"></stop>
        </linearGradient>
        <clipPath id="clip0_2436_148369">
          <path fill="#fff" d="M0 .5h200v25H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}
